import './icons.scss';

import { UntitledIcons, UntitledColorizeIcons, LegacyIcons } from './Icons';
import type {
  UntitledIconProps,
  UntitledColorizeIconProps,
  LegacyIconProps, ReDesignIconProps, IconVariants,
} from "./icon.interface";
import clsx from 'clsx';

function filterIcons(variant: IconVariants, name: string) {

  switch (variant) {
    case 'colorize':
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (UntitledColorizeIcons as any)[name]();
    case 'legacy':
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (LegacyIcons as any)[name]();
    default:
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (UntitledIcons as any)[name]();
  }
}

function Icon ({ size, props, title, variant, name, role }: ReDesignIconProps) {

  let width: number;
  let height: number;
  if (typeof size === "number") {
    width = size;
    height = size;
  } else {
    width = size.width;
    height = size.height;
  }

  return (
    <svg
      fill={variant === 'colorize' ? undefined : 'currentColor'}
      // eslint-disable-next-line react/prop-types
      className={clsx('icon', `icon--${variant}`, props.className)}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      height={height}
      role={role}
      data-testid="icon"
      {...props}
    >
      {title && <title>{title}</title>}
      {filterIcons(variant, name)}
    </svg>
  );
}

export function UntitledIcon({ role = 'img', name, size = 32, title, ...props }:UntitledIconProps) {
  return Icon({ variant: 'untitled', size, title, props, name, role });
}

export function UntitledColorizeIcon ({ role = 'img', name, size = 24, title, ...props }:UntitledColorizeIconProps) {
  return Icon({ variant: 'colorize', size, title, props, name, role });
}

export function LegacyIcon ({ role = 'img', name, size = {width: 130, height: 120}, title, ...props }:LegacyIconProps) {
  return Icon({ variant: 'legacy', size, title, props, name, role });
}
